/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface LeadWaitlistUpdatesInner
 */
export interface LeadWaitlistUpdatesInner {
    /**
     * 
     */
    waitlist_id?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    created_by_user?: User;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the LeadWaitlistUpdatesInner interface.
 */
export function instanceOfLeadWaitlistUpdatesInner(value: object): value is LeadWaitlistUpdatesInner {
    return true;
}

export function LeadWaitlistUpdatesInnerFromJSON(json: any): LeadWaitlistUpdatesInner {
    return LeadWaitlistUpdatesInnerFromJSONTyped(json, false);
}

export function LeadWaitlistUpdatesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWaitlistUpdatesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'waitlist_id': json['waitlist_id'] == null ? undefined : json['waitlist_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'created_by_user': json['created_by_user'] == null ? undefined : UserFromJSON(json['created_by_user']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function LeadWaitlistUpdatesInnerToJSON(json: any): LeadWaitlistUpdatesInner {
    return LeadWaitlistUpdatesInnerToJSONTyped(json, false);
}

export function LeadWaitlistUpdatesInnerToJSONTyped(value?: LeadWaitlistUpdatesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'waitlist_id': value['waitlist_id'],
        'comment': value['comment'],
        'created_by_user_id': value['created_by_user_id'],
        'created_by_user': UserToJSON(value['created_by_user']),
        'created_at': value['created_at'],
    };
}

